export {default} from './PriceInput';
export type {IPriceInputProps} from './PriceInput';
